import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCurrentCompany } from 'javascripts/hooks';
import { Steven } from 'helpers/steven';
import { request, type V3ApiError } from 'javascripts/services/v3ApiClient';
import { PAGE_TEMPLATES_QUERY_KEY } from './useGetPageTemplates';
import { type PageTemplateId } from '../types';

type DeletePageTemplateParams = {
  pageTemplateDbId: PageTemplateId;
};

export const useDeletePageTemplate = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: () => void;
}) => {
  const { currentCompany } = useCurrentCompany();
  const queryClient = useQueryClient();

  return useMutation<void, V3ApiError, DeletePageTemplateParams>({
    mutationFn: async (params: DeletePageTemplateParams) => {
      const { pageTemplateDbId } = params;
      await request({
        url: `page_templates/${pageTemplateDbId}`,
        method: 'delete',
      });
    },
    onSuccess: (_, variables) => {
      onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: [PAGE_TEMPLATES_QUERY_KEY, currentCompany.id],
      });

      const { pageTemplateDbId } = variables;

      Steven.entityCrud({
        entity_id: `${pageTemplateDbId}`,
        entity_type: 'page_template',
        action: 'deleted',
      });
    },
    onError: () => {
      onError?.();
    },
  });
};
